import React, { FunctionComponent, useState } from 'react';
import { HelpCircle } from 'lucide-react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Tooltip, TooltipContent, TooltipTrigger } from '../Tooltip';
import { Dialog, DialogContent, DialogTrigger } from '../Dialog';

interface ExtraHelpProps {
  // markdown is the content (in markdown format) to be displayed in the help dialog.
  markdown?: string;

  // onHoverChange is a callback function that is called when the help icon is hovered or unhovered.  This can be used
  // to highlight the entire component or perform other actions based on the hover state.
  onHoverChange?: (hovering: boolean) => void;
}

// ExtraHelp is a component that displays additional help information in a dialog when the help icon is clicked.
export const ExtraHelp: FunctionComponent<ExtraHelpProps> = ({ markdown = '', onHoverChange = () => {} }) => {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={(o) => setOpen(o)}>
      <DialogTrigger>
        <Tooltip>
          {/* The TooltipTrigger needs to be set to asChild, so it doesn't render a button (that would result in a
          button inside a button error) */}
          <TooltipTrigger asChild>
            <div
              className="cursor-pointer"
              onMouseOver={() => onHoverChange(true)}
              onMouseLeave={() => onHoverChange(false)}
            >
              <HelpCircle />
            </div>
          </TooltipTrigger>
          <TooltipContent>Click for more help</TooltipContent>
        </Tooltip>
      </DialogTrigger>
      <DialogContent className="max-w-screen-xl">
        <Markdown remarkPlugins={[remarkGfm]} className="prose w-full max-w-[1200px]">
          {markdown}
        </Markdown>
      </DialogContent>
    </Dialog>
  );
};
